export default [
  {
    // 系统设置
    path: "/settings",
    name: "settings",
    component: () => import("@/CommonDP/pages/mainMg/settings/settings.vue"),
    meta: {
      routeName: "设置",
      icon: require("@/CommonDP/assets/settings/settings.svg")
    },
    children: [
      {
        path: "/personInfo",
        name: "personInfo",
        component: () => import("@/CommonDP/pages/mainMg/settings/enterprisePerson/index.vue"),
        meta: {
          routeName: "人员管理",
          prouteName: "人员管理",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/personInfo.svg"),
          icon2: require("@/CommonDP/assets/settings/personInfo.svg")
        }
      },
      {
        path: "/addpersonInfo",
        name: "addpersonInfo",
        component: () => import("@/CommonDP/pages/mainMg/settings/enterprisePerson/addPerson.vue"),
        meta: {
          routeName: "人员管理",
          prouteName: "人员管理",
          pname: "设置",
          permissionKey: "personInfo"
        }
      },
      // 更多成员
      {
        path: "/morepersonInfo",
        name: "morepersonInfo",
        component: () => import("@/CommonDP/pages/mainMg/settings/enterprisePerson/moreperson.vue"),
        meta: {
          routeName: "人员管理",
          prouteName: "人员管理",
          pname: "设置",
          permissionKey: "personInfo"
        }
      },
      {
        path: "/systemSet",
        name: "systemSet",
        component: () => import("@/CommonDP/pages/mainMg/settings/systemSet/index.vue"),
        meta: {
          routeName: "系统设置",
          prouteName: "系统设置",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/sysSetting.svg"),
          icon2: require("@/CommonDP/assets/settings/sysSetting.svg")
        }
      },
      {
        path: "/orgFrameworkConfig",
        name: "orgFrameworkConfig",
        component: () => import("@/CommonDP/pages/mainMg/settings/org/index.vue"),
        meta: {
          routeName: "组织架构",
          prouteName: "组织架构",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/orgFrameworkConfig.svg"),
          icon2: require("@/CommonDP/assets/settings/orgFrameworkConfig.svg")
        }
      },
      {
        path: "/rolePowerConfig",
        name: "rolePowerConfig",
        component: () => import("@/CommonDP/pages/mainMg/settings/permission/index.vue"),
        meta: {
          routeName: "权限管理",
          prouteName: "权限管理",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/authorization.svg"),
          icon2: require("@/CommonDP/assets/settings/authorization.svg")
        }
      },
      {
        path: "/journal",
        name: "journal",
        component: () => import("@/CommonDP/pages/mainMg/settings/log/index.vue"),
        meta: {
          routeName: "日志管理",
          prouteName: "日志管理",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/logmanagement.svg"),
          icon2: require("@/CommonDP/assets/settings/logmanagement.svg")
        }
      },
      {
        path: "/rich-text-store",
        name: "rich-text-store",
        component: () => import("@/CommonDP/pages/mainMg/settings/rich-text/index.vue"),
        meta: {
          routeName: "富文本管理",
          prouteName: "富文本管理",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/richTextStore.svg"),
          icon2: require("@/CommonDP/assets/settings/richTextStore.svg")
        }
      },
      {
        path: "/processDefinition",
        name: "processDefinition",
        component: () => import("@/CommonDP/pages/mainMg/settings/process/index.vue"),
        meta: {
          routeName: "流程设置",
          prouteName: "流程设置",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/logoSetting.svg"),
          icon2: require("@/CommonDP/assets/settings/logoSetting.svg")
        }
      },
      {
        path: "/tagManagement",
        name: "tagManagement",
        component: () => import("@/CommonDP/pages/mainMg/settings/tagManagement.vue"),
        meta: {
          routeName: "标签管理",
          prouteName: "标签管理",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/tagManagement.svg"),
          icon2: require("@/CommonDP/assets/settings/tagManagement.svg")
        }
      },
      // {
      //   path: "/vFormDesigner",
      //   name: "vFormDesigner",
      //   component: () => import("@/CommonDP/pages/mainMg/lowcode/vForm/designerFree.vue"),
      //   meta: {
      //     routeName: "低代码设计器",
      //     prouteName: "低代码设计器",
      //     pname: "设置",
      //     icon1: require("@/CommonDP/assets/settings/logoSetting1.png"),
      //     icon2: require("@/CommonDP/assets/settings/logoSetting2.png")
      //   }
      // },
      // {
      //   path: '/vFormRender',
      //   name: 'vFormRender',
      //   component: () => import('@/CommonDP/pages/mainMg/settings/vFormRender/index.vue'),
      //   meta: {
      //     routeName: '低代码渲染',
      //     prouteName: '低代码渲染',
      //     pname: '设置',
      //     icon1: require('@/CommonDP/assets/settings/logoSetting1.png'),
      //     icon2: require('@/CommonDP/assets/settings/logoSetting2.png')
      //   }
      // },
      {
        path: "/formSettings",
        name: "formSettings",
        component: () => import("@/CommonDP/pages/mainMg/lowcode/component/vFormRender.vue"),
        meta: {
          routeName: "表单设置",
          prouteName: "表单设置",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/formSettings.svg"),
          icon2: require("@/CommonDP/assets/settings/formSettings.svg")
        },
        props: {
          hasSubmit: true,
          formId: "8719817736454144"
          // primaryKeyValue: '168723937356677120'
        }
      },
      {
        path: "/onlineUserStatistics",
        name: "onlineUserStatistics",
        component: () => import("@/CommonDP/pages/mainMg/settings/onlineUserStatistics/index.vue"),
        meta: {
          routeName: "在线用户统计",
          prouteName: "在线用户统计",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/userCount.svg"),
          icon2: require("@/CommonDP/assets/settings/userCount.svg")
        }
      },
      {
        path: "/workTimeStatistical",
        name: "workTimeStatistical",
        component: () => import("@/CommonDP/pages/mainMg/settings/workTimeStatistical/index.vue"),
        meta: {
          routeName: "工时统计",
          prouteName: "工时统计",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/workHours.svg"),
          icon2: require("@/CommonDP/assets/settings/workHours.svg")
        }
      },
      {
        path: "/holidaySettings",
        name: "holidaySettings",
        component: () => import("@/CommonDP/pages/mainMg/settings/holidaySettings/index.vue"),
        meta: {
          routeName: "节假日设置",
          prouteName: "节假日设置",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/holidaySettings.svg"),
          icon2: require("@/CommonDP/assets/settings/holidaySettings.svg")
        }
      },
      {
        path: "/sysAnnouncementInfo",
        name: "sysAnnouncementInfo",
        component: () => import("@/CommonDP/pages/mainMg/settings/sysAnnouncementInfo/index.vue"),
        meta: {
          routeName: "公告管理",
          prouteName: "公告管理",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/sysAnnouncementInfo.svg"),
          icon2: require("@/CommonDP/assets/settings/sysAnnouncementInfo.svg")
        }
      },
      {
        path: "/manageVersion",
        name: "manageVersion",
        component: () => import("@/CommonDP/pages/mainMg/settings/manageVersion/index.vue"),
        meta: {
          routeName: "版本管理",
          prouteName: "版本管理",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/manageVersion.svg"),
          icon2: require("@/CommonDP/assets/settings/manageVersion.svg")
        }
      },
      {
        path: "/taskPackage",
        name: "taskPackage",
        component: () => import("@/CommonDP/pages/mainMg/settings/taskPackage/index.vue"),
        meta: {
          routeName: "计划包",
          prouteName: "计划包",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/taskPackage.svg"),
          icon2: require("@/CommonDP/assets/settings/taskPackage.svg")
        }
      },
      {
        // CommonDP/components/commonComponents 组件测试
        path: "/testCommonComponents",
        name: "testCommonComponents",
        component: () => import("@/CommonDP/components/commonComponents/index"),
        meta: {
          routeName: "test"
        }
      },
      {
        path: "/centralFileBackup",
        name: "centralFileBackup",
        component: () => import("@/CommonDP/pages/mainMg/settings/centralFileBackup/index.vue"),
        meta: {
          routeName: "中心文件备份",
          prouteName: "中心文件备份",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/centralFileBackup.svg"),
          icon2: require("@/CommonDP/assets/settings/centralFileBackup.svg")
        }
      },
      {
        path: "/lightMonitoring",
        name: "lightMonitoring",
        component: () => import("@/CommonDP/pages/mainMg/settings/lightMonitoring/index.vue"),
        meta: {
          routeName: "轻量化监控",
          prouteName: "轻量化监控",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/lightMonitoring.svg"),
          icon2: require("@/CommonDP/assets/settings/lightMonitoring.svg")
        }
      },
      {
        path: "/largeScreenDesign",
        name: "largeScreenDesign",
        component: () => import("@/CommonDP/pages/mainMg/settings/largeScreenDesign/index.vue"),
        meta: {
          routeName: "大屏设计",
          prouteName: "大屏设计",
          pname: "设置",
          icon1: require("@/CommonDP/assets/settings/largeScreenDesign.svg"),
          icon2: require("@/CommonDP/assets/settings/largeScreenDesign.svg")
        }
      },
      {
        path: "/light_file",
        name: 'light_file',
        component: () => import('@/CommonDP/pages/mainMg/settings/light_file/index.vue'),
        meta: {
          routeName: '轻量化文件',
          prouteName: '/light_file',
          pname: '/settings',
          icon1: require('@/CommonDP/pages/mainMg/settings/light_file/assets/light_file.svg'),
          icon2: require('@/CommonDP/pages/mainMg/settings/light_file/assets/light_file.svg')
        }
      }
    ]
  }
];
